import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import * as assets from "../../assets/index";
import { iconFor } from "../layouts/techIcons";

const FeaturedProject = ({ title, subtitle, des, highlights = [], tags = [], status, logo, live, github }) => {
  return (
    <div className="card overflow-hidden grid grid-cols-1 lgl:grid-cols-2 group hover:border-designColor/40 duration-500">
      <div className="relative min-h-[280px] flex items-center justify-center bg-gradient-to-br from-[#06101d] via-[#0b1a2c] to-[#060d18] overflow-hidden">
        <div className="absolute w-72 h-72 rounded-full bg-cyan-400/20 blur-3xl group-hover:bg-cyan-400/30 duration-700"></div>
        <div className="absolute w-[380px] h-[380px] rounded-full border border-cyan-300/10"></div>
        <div className="absolute w-[300px] h-[300px] rounded-full border border-cyan-300/10"></div>
        {status && (
          <span className="absolute top-5 left-5 text-xs uppercase tracking-wider px-3 py-1 rounded-full bg-designColor text-white">
            {status}
          </span>
        )}
        {logo && (
          <img
            src={assets[logo]}
            alt={`${title} logo`}
            className="relative w-36 h-36 md:w-44 md:h-44 rounded-[2rem] shadow-2xl shadow-cyan-500/20 group-hover:scale-105 duration-500"
          />
        )}
      </div>
      <div className="p-6 md:p-10 flex flex-col gap-5">
        <div>
          <p className="text-xs uppercase tracking-[3px] text-designColor">Featured · My Product</p>
          <h3 className="text-4xl font-extrabold text-white font-titleFont mt-2">{title}</h3>
          {subtitle && <p className="text-gray-300 mt-1">{subtitle}</p>}
        </div>
        <p className="text-gray-400 leading-7">{des}</p>
        {highlights.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {highlights.map((h) => (
              <span key={h} className="chip">{h}</span>
            ))}
          </div>
        )}
        <div className="flex flex-wrap items-center gap-4 mt-2">
          {live && (
            <a
              href={live}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-designColor text-white font-medium shadow-lg shadow-designColor/30 hover:-translate-y-1 duration-300"
            >
              Visit {title} <FaArrowRight className="text-sm" />
            </a>
          )}
          {github && (
            <a href={github} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-designColor duration-300">
              <BsGithub /> Source
            </a>
          )}
          <div className="flex gap-3 text-xl text-gray-500 ml-auto">
            {tags.map((tag) => (
              <span key={tag} title={tag}>{iconFor(tag)}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedProject;
